import { Component, Input, Output, OnInit, TemplateRef, ViewChild, EventEmitter} from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../common/services/common.service';

@Component({
  selector: 'iposcen-acknowlegement-dialog',
  templateUrl: './acknowlegement-dialog.component.html',
  styleUrls: ['./acknowlegement-dialog.component.scss']
})
export class AcknowlegementDialogComponent implements OnInit {
  @ViewChild('acknowledgeModal') private ackModalContent: TemplateRef<AcknowlegementDialogComponent>;
  @Input() titleText: string;
  @Input() acknowledgementDesc: string;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  langDirection: string;
  constructor(private modalService: NgbModal,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.langDirection = this.commonService.direction;
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.ackModalContent, this.modalOption);
    this.modalRef.result.then().catch((res) => {});
  }

  dismissModal() {
    this.modalRef.dismiss();
  }

}
